import { render, staticRenderFns } from "./checkbox-grid.vue?vue&type=template&id=1b60cfbc&"
import script from "./checkbox-grid.vue?vue&type=script&lang=js&"
export * from "./checkbox-grid.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b60cfbc')) {
      api.createRecord('1b60cfbc', component.options)
    } else {
      api.reload('1b60cfbc', component.options)
    }
    module.hot.accept("./checkbox-grid.vue?vue&type=template&id=1b60cfbc&", function () {
      api.rerender('1b60cfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/checkbox-grid.vue"
export default component.exports